module.exports = __webpack_public_path__ + "static/single-source-icon-101c0469fc755411a4b07438fe8c3737.png";